import { View, Text, Image } from "reshaped";
import { useResponsiveClientValue } from "../../../hooks";
import imgGuille from "../../../images/guillermo.png";

export const IntroBody = (props: { isDark: boolean }) => {
  const { isDark } = props;

  return (
    <View
      direction="row"
      backgroundColor={isDark ? "neutral" : "primary"}
      padding={10}
      gap={10}
    >
      <View.Item columns={useResponsiveClientValue({ s: 12, l: 6 })}>
        <View direction="column" gap={4}>
          <Text variant="title-3">Guillermo A. Araujo Blanco</Text>
          <Text variant="featured-2" weight="bold">
            Desarrollador de software
          </Text>
          <Text variant="body-2">
            Soy un profesional altamente responsable, puntual, ordenado y creativo, con una destacada capacidad de liderazgo y trabajo en equipo. 
            Mi pasión por el crecimiento profesional y el aprendizaje continuo me impulsa a mantenerme a la vanguardia de las tecnologías emergentes y a perfeccionar constantemente mis habilidades. 
            Cuento con una sólida experiencia en digitalización de documentos, análisis e interpretación de información, y relaciones interpersonales, respaldada por conocimientos comprobables en Programacion.
            Como profesional certificado en SAP Commerce Cloud, poseo habilidades avanzadas en JavaScript y Java. 
            He obtenido certificaciones de alto nivel como SAP Commerce Cloud Business User y SAP Commerce Cloud 1905 Developer, que validan mi profundo conocimiento en comercio electrónico. 
            Mi enfoque técnico y proactivo me permite desarrollar soluciones innovadoras y efectivas, listas para impulsar el éxito de cualquier proyecto.
            Estoy preparado para aportar mi experiencia certificada y mi enfoque dinámico y proactivo a su equipo, garantizando la entrega de resultados excepcionales y la superación constante de expectativas. 
            Estoy emocionado por la oportunidad de contribuir con mi experiencia y habilidades para llevar sus proyectos al siguiente nivel.
          </Text>
        </View>
      </View.Item>

      <View.Item columns={useResponsiveClientValue({ s: 12, l: 6 })}>
        <View align="center">
          <Image
            width={useResponsiveClientValue({ s: "200px", l: "300px" })}
            src={imgGuille}
            borderRadius="large"
          />
        </View>
      </View.Item>
    </View>
  );
};
